import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { 
  IconShield, 
  IconMessageSquare, 
  IconBarChart, 
  IconUserCheck, 
  IconSmartphone, 
  IconCamera 
} from '../components/Icons';

const CommunicationSupportView = () => {
  const { t } = useLanguage();
  
  const features = [
    {
      title: t('enhancedSecurity'),
      description: t('enhancedSecurityDesc'),
      icon: IconShield,
      color: 'bg-blue-500',
    },
    {
      title: t('smoothCommunication'),
      description: t('smoothCommunicationDesc'),
      icon: IconMessageSquare,
      color: 'bg-green-500',
    },
    {
      title: t('accountingReporting'),
      description: t('accountingReportingDesc'),
      icon: IconBarChart,
      color: 'bg-purple-500',
    },
    {
      title: t('multiUserManagement'),
      description: t('multiUserManagementDesc'),
      icon: IconUserCheck,
      color: 'bg-orange-500',
    },
    {
      title: t('mobileAppSupport'),
      description: t('mobileAppSupportDesc'),
      icon: IconSmartphone,
      color: 'bg-pink-500',
    },
    {
      title: t('virtualTourSupport'),
      description: t('virtualTourSupportDesc'),
      icon: IconCamera,
      color: 'bg-indigo-500',
    },
  ];

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <h1 className="text-3xl font-bold text-gray-900 mb-8">{t('communicationSupport')}</h1>

      <div className="bg-white rounded-lg shadow-md p-6 mb-8">
        <h2 className="text-xl font-semibold mb-6 text-center">{t('platformSupportFeatures')}</h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white border border-gray-200 rounded-lg p-6 hover:shadow-lg transition-shadow"
            >
              <div className={`${feature.color} w-16 h-16 rounded-full flex items-center justify-center mb-4 mx-auto`}>
                <feature.icon className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 text-center mb-3">
                {feature.title}
              </h3>
              <p className="text-sm text-gray-600 text-center">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>

      <div className="bg-gray-50 rounded-lg p-8 text-center">
        <h3 className="text-2xl font-bold text-gray-900 mb-4">
          More features coming soon
        </h3>
        <p className="text-gray-600 mb-6">
          All-in-One RPMS is continuously evolving based on user feedback.
          We are committed to providing better property rental management experience.
        </p>
        <button className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-8 rounded-full">
          Suggest a Feature
        </button>
      </div>
    </div>
  );
};

export default CommunicationSupportView;
